<template>
    <div>
        <div class="content-caption dashed">
            <span>服务类型</span>
        </div>
        <div class="simple-form">
            <div class="form-group">
                <div class="form-label">
                    <label class="required">服务类型</label>
                </div>
                <div class="form-value ">
                    <el-select v-model="servcAccClaimInfo.servcTypeId" placeholder="请选择" :disabled="id != null">
                        <el-option v-for="item in tableState" :key="item.value" :label="item.text" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>分类信息</span>
            <a v-if="id == null" class="swb-btn-link" @click="selectCatInfo()">选择</a>
        </div>
        <table class="custom-tbl">
            <thead class="head">
            <tr class="row">
                <th style="text-align: left">分类</th>
                <th width="120">分类级别</th>
                <th width="80">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr v-if="catList != null && catList.length > 0" v-for="(item,index) in catList" class="row">
                <td style="text-align: left">
                    <span>{{item.catName}}</span>
                </td>
                <td>
                    <span v-if="item.level == 1">一级</span>
                    <span v-if="item.level == 2">二级</span>
                    <span v-if="item.level == 3">三级</span>
                </td>
                <td>
                    <span v-if="id == null" class="swb-btn swb-btn-link" @click="removeCatInfo(index)">移除</span>
                </td>
            </tr>
            <tr class="row" v-if="catList == null || catList.length <= 0">
                <td colspan="3" style="text-align: center; line-height: 40px;">
                    <span>暂无数据...</span>
                </td>
            </tr>
            </tbody>
        </table>

        <div class="content-caption dashed">
            <span>配件要求</span>
        </div>
        <el-form :model="servcAccClaimInfo" ref="servcAccClaimInfo" :rules="servcAccClaimRules">
            <div class="simple-form">
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">配件名称</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="name">
                            <el-input class="width-2x " v-model="servcAccClaimInfo.name"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">规格</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="spec">
                            <el-input class="width-2x " v-model="servcAccClaimInfo.spec"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">价格下限</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="price">
                            <el-input type="number" class="width-2x " v-model="servcAccClaimInfo.price"></el-input>
                            <div class="form-tips">元</div>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">价格上限</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="price2">
                            <el-input type="number" class="width-2x " v-model="servcAccClaimInfo.price2"></el-input>
                            <div class="form-tips">元</div>
                        </el-form-item>
                        <div class="input-tip error">价格上、下限为零时为不要求</div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">来源要求</label>
                    </div>
                    <div class="form-value ">
                        <el-form-item prop="srcFlag">
                            <el-select v-model="servcAccClaimInfo.srcFlag" placeholder="请选择">
                                <el-option :key="-1" label="无要求" :value="-1"></el-option>
                                <el-option :key="0" label="服务商" :value="0"></el-option>
                                <el-option :key="2" label="授权商" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>备注</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="memo">
                            <el-input class="width-2x" v-model="servcAccClaimInfo.memo" type="textarea" placeholder="请输入备注信息"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf';
    import { checkUserActionPerm } from '../index'
    import { openMerchtFusedServcCategSelectDlg } from '../categ/selectDlg'
    //
    import servcClaimApi from '../../api/servcClaim'
    //
    export default {
        name: 'swb-servc-acc-claim-save',
        props: {
            id: {
                type: Number,
                default: null
            },
            servcTypeId: {
                type: Number,
                default: null
            },
        },
        desc: '服务配件要求-新增',
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };
            let checkPrice = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    if(!Utils.isMoneyStr(value)) {
                        callback(new Error('请输入正确的金额'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                servcAccClaimInfo: {
                    servcTypeId: null,
                    price: 0,
                    price2: 0,
                    srcFlag: -1
                },
                tableState: [],
                catList: [],
                servcAccClaimRules: {
                    name: [{validator: checkNull, trigger: 'blur'}],
                    spec: [{validator: checkNull, trigger: 'blur'}],
                    price: [{validator: checkPrice, trigger: 'blur'}],
                    price2: [{validator: checkPrice, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            this.tableState = getEnumList('workServcType') || [];
            if(!Utils.isNoB(this.servcTypeId)) {
                this.servcAccClaimInfo.servcTypeId = this.servcTypeId;
            }
            //
            let id = this.id;
            if(!Utils.isNoB(id)) {
                this.getServcAccClaimInfo(id);
            }
        },
        methods: {
            getServcAccClaimInfo: function (id) {
                let self = this;
                let theLoad = MsgBox.loading();
                servcClaimApi.getServcAccClaimInfo({id: id}, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let servcAccClaimInfo = result.data || {};
                        let catInfo = {
                            catId: servcAccClaimInfo.servcCatId,
                            catId1: servcAccClaimInfo.servcCatId1,
                            catId2: servcAccClaimInfo.servcCatId2,
                            catId3: servcAccClaimInfo.servcCatId3,
                            catName: servcAccClaimInfo.servcCatName,
                            level: servcAccClaimInfo.servcCatLevel
                        };
                        self.catList.push(catInfo);
                        //
                        self.servcAccClaimInfo = Utils.merge({}, servcAccClaimInfo);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectCatInfo(){
                let self = this;
                let dlgConfig = {
                    multiSelect: true
                };
                let defaultCheckedItems = Utils.merge([], self.catList);
                openMerchtFusedServcCategSelectDlg(dlgConfig, defaultCheckedItems, function (result) {
                    if(result.type == "info") {
                        let resCatList = result.data;
                        //
                        self.catList = Utils.merge([], resCatList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            removeCatInfo: function (index) {
                let catList = this.catList || [];
                catList.splice(index, 1);
                //
                this.catList = Utils.merge([], catList);
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {};
                this.$refs['servcAccClaimInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        let servcAccClaimInfo = self.servcAccClaimInfo;
                        if(Utils.isNoB(servcAccClaimInfo.servcTypeId)) {
                            result.type = "warn";
                            result.message = "请选择服务类型";
                        } else {
                            let catList = self.catList || [];
                            let catIds = catList.pluck('catId');
                            servcAccClaimInfo.servcCatIdList = Utils.merge([], catIds);
                            //
                            result.data = servcAccClaimInfo;
                        }
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>






// WEBPACK FOOTER //
// src/compo/servcClaim/ServcAccClaimSave.vue